export default function Books() {
  const book = {
    id: 1,
    title: 'Pilgrimage Toward The Light',
    year: '2024',
    description: 'A powerful memoir of survival and spiritual transformation',
    cover: 'https://public.readdy.ai/ai/img_res/0c0d2fd7f8546543a11e4b60db83227b.jpg',
    amazonLink: 'https://www.amazon.com/Pilgrimage-Toward-Light-Melinda-Holcomb-ebook/dp/B0D3G2VPZH/ref=sr_1_1?crid=PZFLI7EI7F0T&dib=eyJ2IjoiMSJ9.4l9TXoyWIk_mABQsMZJIjEc-lMRudCU5dCoP4yCw-ME.eGSZWZ4EdD-VVCaiM4FiszdzPOkkbgTNJONrkC5fzPM&dib_tag=se&keywords=Melinda+Holcomb&qid=1765909486&s=digital-text&sprefix=%2Cdigital-text%2C872&sr=1-1'
  };

  return (
    <section id="books" className="bg-[#FAF8F5] py-24" data-product-shop>
      <div className="max-w-7xl mx-auto px-8">
        {/* Featured Book - Centered with Enhanced Design */}
        <div className="max-w-2xl mx-auto">
          <a 
            href={book.amazonLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group cursor-pointer block"
          >
            <div className="relative h-[700px] rounded-3xl overflow-hidden shadow-2xl hover:shadow-[0_25px_60px_-15px_rgba(0,0,0,0.4)] transition-all duration-500 hover:scale-[1.05] bg-gradient-to-br from-amber-50 to-teal-50">
              {/* Decorative Background Elements */}
              <div className="absolute inset-0 bg-gradient-to-br from-amber-100/30 via-transparent to-teal-100/30"></div>
              <div className="absolute top-0 right-0 w-64 h-64 bg-teal-400/10 rounded-full blur-3xl"></div>
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber-400/10 rounded-full blur-3xl"></div>
              
              {/* Book Cover Image */}
              <div className="relative h-full flex items-center justify-center p-12">
                <div className="relative group-hover:scale-105 transition-transform duration-500">
                  {/* Glow Effect */}
                  <div className="absolute inset-0 bg-gradient-to-br from-amber-400/20 to-teal-400/20 blur-2xl group-hover:blur-3xl transition-all duration-500"></div>
                  
                  {/* Book Cover */}
                  <img
                    src={book.cover}
                    alt={book.title}
                    className="relative w-full h-[550px] object-cover object-center rounded-2xl shadow-2xl ring-1 ring-black/5"
                  />
                  
                  {/* Shine Effect on Hover */}
                  <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/0 to-transparent group-hover:via-white/20 transition-all duration-700 rounded-2xl"></div>
                </div>
              </div>

              {/* Floating Info Card */}
              <div className="absolute bottom-8 left-8 right-8 bg-white/95 backdrop-blur-xl rounded-2xl p-6 shadow-xl border border-white/20 transform group-hover:translate-y-[-8px] transition-all duration-500">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center">
                    <i className="ri-book-open-line text-2xl text-white"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-1">{book.title}</h3>
                    <p className="text-sm text-teal-600 font-medium mb-2">{book.year}</p>
                    <p className="text-sm text-gray-600 leading-relaxed">{book.description}</p>
                  </div>
                </div>
                
                {/* Amazon Badge */}
                <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-between">
                  <div className="flex items-center gap-2 text-sm text-gray-500">
                    <i className="ri-star-fill text-amber-400"></i>
                    <span className="font-medium">Available Now</span>
                  </div>
                  <div className="inline-flex items-center gap-2 text-sm font-medium text-teal-600 group-hover:text-teal-700">
                    <span>View on Amazon</span>
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a 
            href={book.amazonLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-gradient-to-r from-gray-900 to-gray-800 text-white px-8 py-4 rounded-full text-base font-medium hover:from-teal-600 hover:to-teal-700 transition-all duration-300 hover:shadow-xl hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-amazon-fill text-xl"></i>
            <span>Get Your Copy on Amazon</span>
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}